import { render, staticRenderFns } from "./UpgradeForm.vue?vue&type=template&id=fbc7473e"
import script from "./UpgradeForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpgradeForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports